import { createIcon } from '@chakra-ui/icons'

const PDFIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <>
      <path
        d="M68.5 83.5h-59C7 83.5 5 81.5 5 79V8c0-2.5 2-4.5 4.5-4.5h44.4L73 20.7V79c0 2.4-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M68.5 83c2.2 0 4-1.8 4-4V21L53.6 4H9.5c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5V8c0-2.8 2.2-5 5-5H54l19.4 17.6V79c.1 2.7-2.2 5-4.9 5z"
        fill="#E1E4EA"
      />
      <path
        d="M73.5 33h-69V8c0-2.8 2.2-5 5-5H55l18.4 17.5V33z"
        fill="#DC4853"
      />
      <path
        d="M55.2 3v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0L55.2 3z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(11.467 21.968)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        PDF
      </text>
      <path
        d="M23.6 74.5c1.2 0 3.3-.8 7.4-8 2.4-1.1 4.9-2 7.4-2.8 1.8-.5 3.6-1 5.5-1.3 2.7 1.7 5.7 2.7 8.8 3 2.7 0 3-1.5 3-2 0-.6-.2-1.3-.7-1.7-1-1-3-1.5-5.9-1.5-1.6 0-3.2.1-4.8.4-1.6-1.1-3.1-2.4-4.2-4-1-1.4-1.8-2.9-2.5-4.4 1.9-5.7 2.3-9.4 1.1-11.1-.5-.7-1.2-1-2-1-.9 0-1.8.4-2.2 1.2-1.5 2.4-.3 7.3 1.2 10.9-.8 2.2-1.6 4.3-2.6 6.4-1 2.2-2.1 4.4-3.3 6.5-3 1.4-7.9 4.1-8.3 6.7-.1.7.1 1.5.6 2 .3.4.9.7 1.5.7zm25.5-12.6c3.4 0 4.4.8 4.6 1 .1.1.2.3.2.4 0 .1-.3.3-1.2.3-2-.1-4-.7-5.8-1.6.8 0 1.5-.1 2.2-.1zM35.9 42.3c.1-.3.4-.4.7-.4.2 0 .4.1.5.3.5.7.6 3-.7 7.3-1.1-3.5-1.2-6.3-.5-7.2zm-1.3 17c.7-1.6 1.4-3.1 2-4.7v.1-.1c.6 1.1 1.2 2.1 1.8 3 .9 1.3 2 2.4 3.2 3.3h-.2.1c-1.3.3-2.5.6-3.7 1-1.8.5-3.7 1.2-5.4 1.9l.1-.1h-.1c.8-1.4 1.5-2.9 2.2-4.4zM23.1 72.1c.1-.8 1.7-2.4 4.8-4.1-2.8 4.4-4.1 4.7-4.4 4.7-.1 0-.2-.1-.3-.2-.1-.1-.1-.3-.1-.4z"
        fill="#E1E4EB"
      />
    </>
  ),
})

export default PDFIcon
